import axios from 'axios';
import {API_URL} from "../config/constant";

export const backgroundService = {
    async getBackground() {
        return axios({
            method: 'GET',
            url: `${API_URL}/setting/bg_list`
        })
            .then(function (response) {
                return response.data
            }).catch(() => {
                return false
            });
    },


    async addBackground(file) {
        let form = new FormData();
        form.append("file", file);

        return axios({
            method: 'POST',
            url: `${API_URL}/setting/add_bg`,
            data: form
        })
            .then(function (response) {
                return response.data
            }).catch(() => {
                return false
            });
    },


    async deleteBackground(id) {
        return axios({
            method: 'GET',
            url: `${API_URL}/setting/delete_bg/${id}`,
        })
            .then(function (response) {
                return response.data
            }).catch(() => {
                return false
            });
    },


};
